import {
  EMarketingCenterFormats,
  IMarketingCenterFormat
} from '@/models/marketingCenter/format';
import { ICanvasElement } from '@/models/marketingCenter/canvas';

class InstagramPostFormat implements IMarketingCenterFormat {
  constructor(elements: ICanvasElement[]) {
    this.elements = elements;
  }

  key = EMarketingCenterFormats.instagramPost;
  name = 'Instagram Post';
  elements: ICanvasElement[] = [];
  canvas = {
    width: 251,
    height: 251
  };
  asset = {
    width: 1080,
    height: 1080
  };
  share = {
    width: 74,
    height: 74,
    icon: 'instagram'
  };
}

export default InstagramPostFormat;
